export default "__VITE_ASSET__GTLObahM__"